import SidebarContainer from '../../../containers/SidebarContainer'
import { WrapperPageMainWrapper, WrapperPagePanelWrapper, WrapperPageHeaderWrapper, WrapperPageTitle, WrapperPageCloseButton, WrapperPageContentWrapper, WrapperPageTitleWrapper } from './PageElements'

const WrapperPageWithSecondNav = ({
    pageTitle = '',
    pageTitleTransId = '',
    navChildren,
    children,
    closePagePath = false,
    handleScroll = false,
    id = false,
    navWide = false,
}) => (
    <WrapperPageMainWrapper>
        <SidebarContainer />
        <div className={`second-nav-panel${navWide ? ' second-nav-panel--wide' : ''}`}>
            {navChildren}
        </div>
        <WrapperPagePanelWrapper handleScroll={handleScroll} addClassName={`main-panel--with-second-nav${navWide ? ' main-panel--with-wide-second-nav' : ''}`}>
            <WrapperPageHeaderWrapper>
                <WrapperPageTitleWrapper>
                    <WrapperPageTitle pageTitle={pageTitle} pageTitleTransId={pageTitleTransId} id={id} />
                </WrapperPageTitleWrapper>
                <WrapperPageCloseButton closePagePath={closePagePath} />
            </WrapperPageHeaderWrapper>
            <WrapperPageContentWrapper>
                {children}
            </WrapperPageContentWrapper>
        </WrapperPagePanelWrapper>
    </WrapperPageMainWrapper>
)

export default WrapperPageWithSecondNav
